(() => {
  'use strict';
  let active = false;

  window.themeCartOffer = {
    open(productForm) {
      const template = productForm.querySelector('template[data-cart-offer]');
      if (!template || active || !window.HTMLDialogElement) return false;
      const variants = JSON.parse(template.content.querySelector('[data-offer-variants]').textContent);
      let variant = variants.find(item => item.available);
      if (!variant) return false;

      const dialog = document.createElement('dialog');
      dialog.className = 'cart-offer';
      dialog.setAttribute('aria-labelledby', 'cart-offer-heading');
      dialog.innerHTML = '<h2 class="cart-offer__heading" id="cart-offer-heading">Complete your order</h2><button type="button" class="cart-offer__close" aria-label="Close offer">×</button>';
      dialog.append(template.content.cloneNode(true));
      dialog.querySelector('[data-offer-variants]').remove();
      const find = selector => dialog.querySelector(selector);
      const add = find('[data-offer-add]');
      const quantity = find('[data-offer-quantity]');
      const error = find('[data-offer-error]');
      const options = [...dialog.querySelectorAll('[data-option-index]')];
      const selected = [...variant.options];
      const originalImage = find('.cart-offer__image')?.getAttribute('src');
      const returnFocus = productForm.submitButton || document.activeElement;
      let busy = false;
      let added = false;
      const money = value => window.theme.formatMoney(value, window.theme.moneyFormat);

      function render() {
        options.forEach((group, index) => {
          group.querySelectorAll('[data-option-value]').forEach(button => {
            button.setAttribute('aria-pressed', String(button.dataset.optionValue === selected[index]));
          });
        });
        variant = variants.find(item => item.options.every((value, index) => value === selected[index]));
        add.disabled = !variant?.available;
        add.textContent = variant?.available ? 'ADD TO MY ORDER' : 'UNAVAILABLE';
        find('[data-offer-price]').innerHTML = variant ? money(variant.price) : '—';
        const sale = variant && variant.compare_at_price > variant.price;
        find('[data-offer-compare]').hidden = !sale;
        find('[data-offer-discount]').hidden = !sale;
        if (sale) {
          find('[data-offer-compare]').innerHTML = money(variant.compare_at_price);
          find('[data-offer-discount]').textContent = `−${Math.round((1 - variant.price / variant.compare_at_price) * 100)}%`;
        }
        const photo = find('.cart-offer__image');
        if (photo) {
          photo.removeAttribute('srcset');
          photo.src = variant?.featured_image?.src || originalImage;
        }
        const rule = variant?.quantity_rule;
        quantity.min = rule?.min || 1;
        quantity.step = rule?.increment || 1;
        if (rule?.max) quantity.max = rule.max;
        else quantity.removeAttribute('max');
        quantity.value = quantity.min;
      }

      dialog.addEventListener('click', event => {
        const button = event.target.closest('[data-option-value]');
        if (button && !busy) {
          selected[Number(button.closest('[data-option-index]').dataset.optionIndex)] = button.dataset.optionValue;
          error.textContent = '';
          render();
        }
        if (event.target.closest('[data-quantity-minus]') && !busy) quantity.stepDown();
        if (event.target.closest('[data-quantity-plus]') && !busy) quantity.stepUp();
        if (event.target.closest('.cart-offer__close') && !busy) dialog.close();
        if (event.target === dialog && !busy) {
          const box = dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
        }
      });
      dialog.addEventListener('cancel', event => { if (busy) event.preventDefault(); });
      find('.cart-offer__checkout').addEventListener('click', event => {
        event.preventDefault();
        if (!busy) dialog.close();
      });
      dialog.addEventListener('close', () => {
        active = false;
        document.documentElement.classList.remove('cart-offer-open');
        dialog.remove();
        if (returnFocus?.isConnected) returnFocus.focus({preventScroll: true});
        if (productForm.isCartDrawer) {
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', {bubbles: true}));
        } else {
          window.location.assign(window.theme.routes.cart_url);
        }
      }, {once: true});
      add.addEventListener('click', async () => {
        if (busy || added || !variant?.available || !quantity.reportValidity()) return;
        busy = true;
        add.disabled = true;
        quantity.disabled = true;
        add.textContent = 'ADDING…';
        error.textContent = '';
        try {
          const response = await fetch(window.theme.routes.cart_add_url, {
            method: 'POST',
            headers: {'Content-Type': 'application/json', Accept: 'application/json'},
            body: JSON.stringify({items: [{id: variant.id, quantity: Number(quantity.value)}]})
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : 'Unable to add this item. Please try again.');
          added = true;
          busy = false;
          dialog.close();
        } catch (failure) {
          error.textContent = failure.message || 'Unable to add this item. Please try again.';
          add.disabled = false;
          add.textContent = 'ADD TO MY ORDER';
        } finally {
          busy = false;
          quantity.disabled = false;
        }
      });
      render();
      document.body.append(dialog);
      dialog.showModal();
      document.documentElement.classList.add('cart-offer-open');
      active = true;
      return true;
    }
  };
})();
